import React from "react"
import { Popover } from "react-bootstrap"
import reggie from "src/utilities/Reggie"
import PortalRoleAndAssignmentTypes from "../../types/portalRoleTypes/PortalRoleAndAssignmentTypes"
import "./RMAudit.css"

const rmAudit = {
    auditRAA: (raa: PortalRoleAndAssignmentTypes) => {
        const roleKeys = ["RoleName", "RoleCategory", "Description"] as const
        const assignmentKeys = ["Target"] as const
        const { Role: role, Assignments: assignments } = raa
        let queuedForDelete = 0

        let result = {
            canSave: true,
            roleIssues: [] as string[],
            missingTargets: 0,
            noAssignments: false
        }

        for (const rk of roleKeys) {
            if (!role[rk]) {
                result.canSave = false
                result.roleIssues.push(reggie.deCamel(rk))
            }
        }

        for (const assignment of assignments) {
            const hasMissingTarget = assignmentKeys.some(ak => !assignment[ak] && !assignment.DeletedDate)
            if (hasMissingTarget) {
                result.missingTargets++
            }
            if (assignment.DeletedDate) {
                queuedForDelete++
            }
        }

        result.noAssignments = assignments.length === 0 || queuedForDelete === assignments.length

        if (result.noAssignments || result.missingTargets > 0) {
            result.canSave = false
        }

        return result
    },
    rmAuditPopover: (title1: string | null, texts1: string[] | null, title2: string | null, texts2: string[] | null) => (
        <Popover id="rm-audit-popover">
            {title1 && texts1 &&
                <>
                    <Popover.Title>
                        <div className="RMAuditPopoverTitle">
                            {title1}
                        </div>
                    </Popover.Title>
                    <Popover.Content>
                        {texts1.map((text, i) =>
                            <div key={i} className="RMAuditPopoverContent">
                                <p>{text}</p>
                            </div>
                        )}
                    </Popover.Content>
                </>
            }
            {(title2 && texts2) &&
                <>
                    <Popover.Title>
                        <div className="RMAuditPopoverTitle">
                            {title2}
                        </div>
                    </Popover.Title>
                    <Popover.Content>
                        {texts2.map((text, i) =>
                            <div key={i} className="RMAuditPopoverContent">
                                <p>{text}</p>
                            </div>
                        )}
                    </Popover.Content>
                </>
            }
        </Popover>
    )
}

export default rmAudit